export enum ImageViewerStatusEnum {
	LOADING = 'loading',
	LOADED = 'loaded',
	ERROR = 'error',
}

export type ImageViewerStatusEnumValues = `${ImageViewerStatusEnum}`;
